import { useRef } from 'react';
import { mark, measureAndLog } from '@hotjar/performance';
import { MARKS } from '@hotjar/webapp/performance';

export const useHeatmapsPerformance = (): {
  startMeasurement: () => void;
  finishMeasurement: () => void;
} => {
  const measuredOnce = useRef(false);

  const startMeasurement = () => {
    mark(MARKS.HEATMAPS_VIEW_USER_ATTRS_START);
  };

  const finishMeasurement = () => {
    if (measuredOnce.current === true) {
      return;
    }

    measureAndLog({
      name: MARKS.HEATMAPS_VIEW_USER_ATTRS_TIME,
      startMark: MARKS.HEATMAPS_VIEW_USER_ATTRS_START,
    });

    measuredOnce.current = true;
  };

  return {
    startMeasurement,
    finishMeasurement,
  };
};
